'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = "";
styleInject_es(css_248z);
